import GlobalContext from '../bootstrap';
import initUserItemsGrid from '../user/saved-items-grid';
import { initActivateAlertsCTA } from '../user/activate-alerts-form';
import { disableAlert, disableAlertHandler, enableAlertHandler } from '../user/alerts';
class UserAlertsPage extends GlobalContext {
    constructor() {
        super();
        this._initialiseComponents();
    }

    _initialiseComponents(): void {
        initUserItemsGrid();

        if ( window.alertToDisableID ) {
            disableAlert( window.alertToDisableID );
        }

        enableAlertHandler();

        disableAlertHandler();

        const activateAlertsCTA = document.querySelector( '.activateemailscta' ) as HTMLElement;

        if ( activateAlertsCTA ) {
            initActivateAlertsCTA( activateAlertsCTA );
        }
    }
}

if ( !window.userAlertsPage ) {
    window.userAlertsPage = new UserAlertsPage();
}
